import api from './api';

export const getCourses = (params) =>
    api.get('/courses', { params });

export const getCourse = (id) =>
    api.get(`/courses/${id}`);

export const createCourse = (data) =>
    api.post('/courses', data);

export const updateCourse = (id, data) =>
    api.put(`/courses/${id}`, data);

export const deleteCourse = (id) =>
    api.delete(`/courses/${id}`);

export const publishCourse = (id) =>
    api.patch(`/courses/${id}/publish`);

export const getCatalog = (params) =>
    api.get('/catalog', { params });

// Modules
export const createModule = (courseId, data) =>
    api.post(`/courses/${courseId}/modules`, data);

export const updateModule = (id, data) =>
    api.put(`/modules/${id}`, data);

export const deleteModule = (id) =>
    api.delete(`/modules/${id}`);

export const reorderModules = (modules) =>
    api.put('/modules/reorder', { modules });

// Lessons
export const createLesson = (moduleId, data) =>
    api.post(`/modules/${moduleId}/lessons`, data);

export const getLesson = (id) =>
    api.get(`/lessons/${id}`);

export const updateLesson = (id, data) =>
    api.put(`/lessons/${id}`, data);

export const deleteLesson = (id) =>
    api.delete(`/lessons/${id}`);

export const uploadFile = (lessonId, formData, onProgress) =>
    api.post(`/lessons/${lessonId}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress,
    });

export const deleteFile = (lessonId, path) =>
    api.delete(`/lessons/${lessonId}/file`, { data: { path } });

// Video upload (HLS)
export const uploadVideo = (lessonId, formData, onProgress) =>
    api.post(`/lessons/${lessonId}/upload-video`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 600000, // 10 min
        onUploadProgress: onProgress,
    });

export const deleteVideo = (lessonId) =>
    api.delete(`/lessons/${lessonId}/video`);

// Lesson reorder
export const reorderLessons = (lessons) =>
    api.put('/lessons/reorder', { lessons });

// Tests
export const createTest = (lessonId, data) =>
    api.post(`/lessons/${lessonId}/tests`, data);

export const updateTest = (testId, data) =>
    api.put(`/tests/${testId}`, data);

export const addQuestion = (testId, data) =>
    api.post(`/tests/${testId}/questions`, data);

export const updateQuestion = (questionId, data) =>
    api.put(`/questions/${questionId}`, data);

export const deleteQuestion = (questionId) =>
    api.delete(`/questions/${questionId}`);

export const importTestQuestions = (testId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/tests/${testId}/import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const getTestImportTemplateUrl = () =>
    `${api.defaults.baseURL}/tests/import-template`;
